import { inject, Injectable } from '@angular/core';
import { AlertController, AlertOptions } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { AlertOverlayEventDetail } from '../models/dialog-overlay-event-detail';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  alertController = inject(AlertController);

  async alert<D, R extends string>(options: AlertOptions): Promise<OverlayEventDetail<D>> {
    const alert = await this.alertController.create(options);
    await alert.present();
    const result = await alert.onDidDismiss<D>();
    return result as AlertOverlayEventDetail<R>;
  }
}